const id_purch_quotation = {
    "": "permintaan penawaran",
    add: "buat permintaan penawaran",
    detail: "detail permintaan penawaran",
    add_mitra: "buat permintaan penawaran mitra",

    message: {
        cancel_title: "Apakah Anda yakin untuk membatalkan permintaan?",
        cancel_text: "Masukkan alasan pembatalan permintaan.",

        reject_title: "Apakah Anda yakin untuk menolak permintaan?",
        reject_text: "Masukkan alasan penolakan permintaan.",
    },

    error: {
        create: "Gagal membuat permintaan penawaran.",
        edit: "Gagal mengubah permintaan penawaran.",

        reject: "Gagal membatalkan permintaan penawaran.",
        approve: "Gagal memproses PO.",
        done: "Gagal menyelesaikan permintaan penawaran.",
    },

    success: {
        create: "Berhasil membuat permintaan penawaran.",
        edit: "Berhasil mengubah permintaan penawaran.",

        reject: "Berhasil membatalkan permintaan penawaran.",
        approve: "Berhasil memproses PO.",
        done: "Berhasil menyelesaikan permintaan penawaran.",
    },
}

export default id_purch_quotation;